import { Link, createFileRoute } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";

import { CampaignDetail } from "@/components/campanhas/CampaignDetail";
import { searchToQuery, validateCampaignSearch } from "@/lib/campaigns";
import { presetPeriod } from "@/lib/reports";

export const Route = createFileRoute("/revendedor/_area/campanhas/$campanhaId")({
  validateSearch: validateCampaignSearch,
  head: () => ({ meta: [{ title: "Campanha — Revenda MonteBox" }] }),
  component: ResellerCampaign,
});

function ResellerCampaign() {
  const { campanhaId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const { from, to } = searchToQuery(search, presetPeriod("30d"));

  return (
    <div className="flex flex-col gap-4">
      <Link
        to="/revendedor/campanhas"
        search={{ de: from, ate: to }}
        className="flex w-fit items-center gap-1.5 text-sm font-semibold text-mb-muted hover:text-mb-navy"
      >
        <ArrowLeft className="h-4 w-4" />
        Campanhas
      </Link>
      <CampaignDetail
        side="reseller"
        campaignId={campanhaId}
        period={{ from, to }}
        onPeriodChange={(next) => void navigate({ search: { de: next.from, ate: next.to } })}
      />
    </div>
  );
}
